import { api } from "./api";

const CONSENT_KEY = "pm_consent";

export function getConsent() {
  return localStorage.getItem(CONSENT_KEY); // "accepted" | "rejected" | null
}

export function setConsent(value) {
  localStorage.setItem(CONSENT_KEY, value);
}

// Privacy-conscious event tracking. Only sends analytics events when the user
// has accepted. Never collects personal data — just event name + calculator.
export function track(event, payload = {}) {
  if (getConsent() !== "accepted") return;
  api.post("/events", { event, ...payload }).catch(() => {});
}
